import React, { PureComponent } from 'react';

export class NavFooter extends PureComponent {
  static displayName = NavFooter.name;

  render() {
    return (
      <footer className="pwx-main-footer">
        <div className="pwx-footer-container">
          <table className="pwx-footer-table">
            <tbody>
            <tr>
              <td className="pwx-footer-left">{this.props.userName}</td>
              <td className="pwx-footer-center">
                <div className="pwx-copyright-major-text">{this.props.applicationName}</div>
                <div className="pwx-copyright-minor-text">Copyright &copy; 2022-2026 Powerex Corporation</div>
              </td>
                <td className="pwx-footer-right">{this.props.applicationVersionInfo}</td>
              </tr>
              </tbody>
          </table>
         </div>
      </footer>
    );
  }
}